import React, { useMemo } from "react";
import { MARQUEE_WORDS, STARLIGHT_HEADLINE, STARLIGHT_QUOTE } from "../data/content";

const Stars = () => {
  const stars = useMemo(
    () =>
      Array.from({ length: 44 }).map((_, i) => ({
        id: i,
        top: Math.random() * 100,
        left: Math.random() * 100,
        size: Math.random() * 2 + 1,
        delay: Math.random() * 4,
        dur: Math.random() * 3 + 3,
      })),
    []
  );
  return (
    <div className="pointer-events-none absolute inset-0" aria-hidden="true">
      {stars.map((s) => (
        <span
          key={s.id}
          className="star"
          style={{
            top: `${s.top}%`,
            left: `${s.left}%`,
            width: s.size,
            height: s.size,
            animationDelay: `${s.delay}s`,
            animationDuration: `${s.dur}s`,
          }}
        />
      ))}
    </div>
  );
};

export const Marquee = () => {
  const items = [...MARQUEE_WORDS, ...MARQUEE_WORDS];
  return (
    <section className="relative bg-mds-navy pt-16 pb-8 sm:pt-20 sm:pb-10" data-testid="marquee-section">
      <Stars />
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_50%_120%,rgba(201,162,76,0.18),transparent_60%)]" />

      <div className="relative mx-auto mb-8 max-w-5xl px-6 text-center sm:mb-10">
        <div className="font-display text-3xl font-bold italic leading-[1.4] sm:flex sm:flex-col sm:gap-4 sm:text-5xl lg:text-[3.25rem]">
          {STARLIGHT_HEADLINE.map((line, i) => (
            <span key={i} className="gold-glimmer sm:block sm:pb-[0.12em]">
              {line}{" "}
            </span>
          ))}
        </div>
        <p className="mx-auto mt-5 max-w-3xl font-display text-2xl italic leading-snug text-mds-cream/90 sm:text-3xl">
          {STARLIGHT_QUOTE}
          <span className="font-semibold text-mds-cream whitespace-nowrap">Million Dollar Shot</span>
        </p>
      </div>

      <div
        className="overflow-hidden pb-2 pt-8"
        style={{
          WebkitMaskImage:
            "linear-gradient(to right, transparent 0, #000 7%, #000 93%, transparent 100%)",
          maskImage:
            "linear-gradient(to right, transparent 0, #000 7%, #000 93%, transparent 100%)",
        }}
      >
        <div className="marquee items-center gap-14" aria-hidden="true">
          {items.map((w, i) => (
            <div key={i} className="flex items-center gap-14">
              <span className="whitespace-nowrap px-10 pb-10 pt-4 font-script text-5xl leading-[2.1] text-gold sm:text-7xl">{w}</span>
              <span className="text-2xl text-mds-goldlt">✦</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
